export const limitStringCharacters = (input: string, numberOfCharacters: number) => {
  if (input.length > numberOfCharacters) {
    return `${input.substring(0, numberOfCharacters)}...`;
  }
  return input;
};
